import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { QuoteModal } from "./QuoteModal";
import { Phone } from "lucide-react";

const About = () => {
  return (
    <section className="py-20 bg-white border-t border-neutral-100 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-semibold text-primary uppercase tracking-wider text-sm">Über uns</span>
            <h2 className="font-heading text-3xl md:text-5xl mt-2 mb-6">Zuverlässige Umzugsservice Leistungen</h2>
            <p className="text-lg text-neutral-600 font-medium mb-8 leading-relaxed">
              Seit über 10 Jahren wächst Easy Umzug Transport Möbelmontage vom kleinen Stadtumzug zum europaweiten Umzugsservice. Heute ergänzen wir unsere Arbeit mit Umzugsservice, Möbelmontage und weiteren Leistungen – immer mit Fokus auf echter Kundenzufriedenheit.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <QuoteModal>
                <Button size="lg" className="w-full sm:w-auto">
                  Kostenloses Angebot anfordern &rarr;
                </Button>
              </QuoteModal>
              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto">
                <a href="tel:+4915888640762">
                  <Phone className="w-5 h-5 mr-2" />
                  +49 15888 640762
                </a>
              </Button>
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-primary translate-x-4 translate-y-4 z-0 transition-transform duration-500 group-hover:translate-x-6 group-hover:translate-y-6"></div>
            <img 
              src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df934b202f6855b43c43.jpg" 
              alt="Zuverlässige Umzugsservice Leistungen" 
              width="1200"
              height="800"
              loading="lazy"
              decoding="async"
              className="relative z-10 w-full h-auto object-cover shadow-lg transition-transform duration-500 group-hover:-translate-y-2 group-hover:-translate-x-2"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;